import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { FaSearch } from 'react-icons/fa';

import { BookingDropdown } from 'components/bookingDropdown';
import { BookingPopoverCalendar } from 'components/bookingPopoverCalendar';
import { Picker } from 'components/picker';

import { searchKeys } from '../../constants';
import { getLanguageCode } from 'lib';
import { useGetBookingData } from 'hooks';
import { setCurrency, setLanguage, updateSearchKey } from 'features/userSlice';

import './BigBookingWidgetHeader.css';
import { Cart } from 'features/cart';

// TODO: REMOVE INLINE STYLES AND ADD THEM TO THE CSS FILE
// TODO: DO SOMETHING ABOUT THE CLCIK HANDLERS
const BigBookingWidgetHeader = ({ propertyId }) => {
    const dispatch = useDispatch();

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    const hasCart = useSelector(
        (state) => state.miniBookingWidget?.data?.hasCart
    );
    const countries =
        useSelector(
            (state) => state.miniBookingWidget?.data?.pluginCountries
        ) || [];
    const currencies =
        useSelector((state) => state.miniBookingWidget?.data?.pluginCurrency) ||
        [];

    const adults = useSelector(
        (state) => state.miniBookingWidget?.data?.ourPrice?.adults
    );

    const numberOfRooms = useSelector(
        (state) => state.miniBookingWidget?.data?.ourPrice?.rooms
    );

    const calendarAlert = useSelector((state) => state.user?.calendarAlert);

    let countryCode = getLanguageCode();

    const selectedCurrency = currencies.find((currency) => {
        return currency.currencySelected === 'selected';
    });
    const selectedCountry = countries.find((country) => {
        if (!countryCode) {
            countryCode = useSelector(
                (state) => state.miniBookingWidget?.data?.langCode
            );
        }
        return country.countryCode === countryCode;
    });

    const { getBookingData } = useGetBookingData();

    const handleCurrencyChange = (currencyCode) => {
        dispatch(setCurrency({ currency: currencyCode }));
        getBookingData({ currency: currencyCode });
    };

    const handleLanguageChange = async (countryCode) => {
        await dispatch(setLanguage({ language: countryCode }));
        getBookingData({ language: countryCode });
    };

    useEffect(() => {
        // Set initial values
        dispatch(setCurrency({ currency: selectedCurrency?.currencyCode }));
        dispatch(setLanguage({ language: selectedCountry?.countryCode }));
        dispatch(
            updateSearchKey({ key: searchKeys.ADULTS, value: adults || 1 })
        );
        dispatch(
            updateSearchKey({
                key: searchKeys.NUMBER_OF_ROOMS,
                value: numberOfRooms || 1,
            })
        );
    }, []);

    return (
        <div className="ab-header">
            <section className="ab-search-filters">
                <div className="ab-search-filters-wrapper">
                    <div className="ab-search-filters-inner">
                        <div className="ab-search-form-container">
                            <div>
                                <div>
                                    <div className="ab-search-form-container-inner">
                                        <div className="ab-search-filters-left">
                                            <div className="ab-search-form-fields">
                                                <BookingPopoverCalendar />
                                                <BookingDropdown />
                                            </div>

                                            <div
                                                className={`ab-search-submit ${
                                                    calendarAlert
                                                        ? 'ab-search-submit--disabled'
                                                        : ''
                                                }`}
                                            >
                                                <button
                                                    role="button"
                                                    className="ab-btn ab-search-submit-button"
                                                    tabIndex="0"
                                                    aria-disabled={Boolean(
                                                        calendarAlert
                                                    )}
                                                    title=""
                                                    type="submit"
                                                    // TODO: REPLACE THIS
                                                    aria-label="Αναζήτηση"
                                                    onClick={() =>
                                                        getBookingData({
                                                            propertyId:
                                                                propertyId,
                                                        })
                                                    }
                                                    disabled={Boolean(
                                                        calendarAlert
                                                    )}
                                                >
                                                    <div className="ab-btn-container">
                                                        <div className="ab-btn-content">
                                                            <FaSearch
                                                                size={24}
                                                            />
                                                        </div>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="ab-lang-and-curr">
                                            <Picker
                                                type="country"
                                                data={countries}
                                                value={selectedCountry}
                                                onChange={handleLanguageChange}
                                                title={Lang?.selectYourLanguage}
                                            />
                                            <Picker
                                                type="currency"
                                                data={currencies}
                                                value={selectedCurrency}
                                                onChange={handleCurrencyChange}
                                                title={Lang?.selectYourCurrency}
                                            />
                                            {hasCart && <Cart />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

BigBookingWidgetHeader.propTypes = {
    propertyId: PropTypes.string,
};

export default BigBookingWidgetHeader;
